/** Application roles used for authorization checks. */
export enum Role {
  /** Platform-wide administrator with cross-clinic access. */
  SUPER_ADMIN = 'SUPER_ADMIN',
  /** Clinic owner or manager with full clinic access. */
  CLINIC_ADMIN = 'CLINIC_ADMIN',
  /** Licensed provider who sees patients and manages availability. */
  DOCTOR = 'DOCTOR',
  /** Front-desk staff who manage appointments and patients. */
  RECEPTIONIST = 'RECEPTIONIST',
}

/** Lifecycle states for an appointment. */
export enum AppointmentStatus {
  SCHEDULED = 'SCHEDULED',
  CONFIRMED = 'CONFIRMED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  /** Patient did not attend the scheduled visit. */
  NO_SHOW = 'NO_SHOW',
}

/** Reason categories for booking an appointment. */
export enum AppointmentType {
  CONSULTATION = 'CONSULTATION',
  FOLLOW_UP = 'FOLLOW_UP',
  EMERGENCY = 'EMERGENCY',
}

/** How the appointment is conducted. */
export enum AppointmentMedia {
  IN_PERSON = 'IN_PERSON',
  TELEHEALTH = 'TELEHEALTH',
  PHONE = 'PHONE',
}

/** Recurrence pattern for appointment series. */
export enum RecurrenceType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

/** Scope when editing or deleting a recurring appointment. */
export enum SeriesUpdateType {
  SINGLE = 'SINGLE',
  NOW_AND_FUTURE = 'NOW_AND_FUTURE',
  FUTURE = 'FUTURE',
  ALL = 'ALL',
}

/** RSVP / invite response state. */
export enum InviteStatus {
  INVITED = 'INVITED',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
}

/** Days of the week for recurring availability rules. */
export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

/** Patient gender options. */
export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

/** External calendar provider for OAuth integrations. */
export enum CalendarProvider {
  GOOGLE = 'GOOGLE',
  OUTLOOK = 'OUTLOOK',
}

/** Connection health of a doctor's external calendar integration. */
export enum CalendarIntegrationStatus {
  ACTIVE = 'ACTIVE',
  DISCONNECTED = 'DISCONNECTED',
  ERROR = 'ERROR',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
}

/** Processing state for async calendar sync jobs. */
export enum CalendarSyncJobStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

/** Trigger type for calendar sync background jobs. */
export enum CalendarSyncJobType {
  WEBHOOK = 'WEBHOOK',
  RECONCILE = 'RECONCILE',
  MANUAL = 'MANUAL',
}

/** Common query parameters for paginated list endpoints. */
export interface PaginationOptions {
  page: number;
  limit: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
}
